import { Button } from '@heidi/design-system/button';
import { Loader2, Square } from 'lucide-react';
import { useIntl } from 'react-intl';

import { computerUseMessages } from '../../../data/projects/components/ComputerUseTaskBlock.status.utils';

import type { JSX } from 'react';

export interface ComputerUseStopButtonProps {
  onCancel?: () => void;
  /** Remains disabled until the harness confirms cancellation. */
  stopping?: boolean;
}

export const ComputerUseStopButton = ({
  onCancel,
  stopping = false,
}: ComputerUseStopButtonProps): JSX.Element => {
  const intl = useIntl();

  return (
    <Button
      size="sm"
      variant="secondary"
      onClick={stopping ? undefined : onCancel}
      disabled={stopping}
      className="shrink-0 gap-1.5"
      aria-label={intl.formatMessage(
        stopping ? computerUseMessages.stoppingLabel : computerUseMessages.stopLabel
      )}
    >
      {stopping ? (
        <>
          <Loader2 className="size-3 motion-safe:animate-spin" />
          {intl.formatMessage(computerUseMessages.stopping)}
        </>
      ) : (
        <>
          <Square className="size-3 fill-current" />
          {intl.formatMessage(computerUseMessages.stop)}
        </>
      )}
    </Button>
  );
};
